import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import authService from './authService';

const declarationApi = axios.create({
  baseURL: `${API_BASE_URL}/declarations`,
  headers: { 'Content-Type': 'application/json' },
});

declarationApi.interceptors.request.use((config) => {
  const token = authService.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const declarationService = {
  calculate: (employeeId, year, month) =>
    declarationApi.post('/calculate', null, { params: { employeeId, year, month } }),
  calculatePeriod: (year, month) =>
    declarationApi.post('/calculate-period', null, { params: { year, month } }),
  validate: (id) => declarationApi.put(`/${id}/validate`),
  submit: (id) => declarationApi.put(`/${id}/submit`),
  getByEmployee: (employeeId, year, month) =>
    declarationApi.get(`/employee/${employeeId}`, { params: { year, month } }),
  getByEmployeeYear: (employeeId, year) =>
    declarationApi.get(`/employee/${employeeId}`, { params: { year } }),
  getByEmployeeRange: (employeeId, startYear, startMonth, endYear, endMonth) =>
    declarationApi.get(`/employee/${employeeId}`, { params: { startYear, startMonth, endYear, endMonth } }),
  getByPeriod: (year, month) => declarationApi.get('/period', { params: { year, month } }),
  exportPdf: async (employeeId, year, month) => {
    const res = await declarationApi.get('/export/pdf', {
      params: { employeeId, year, month },
      responseType: 'blob',
    });
    downloadBlob(res.data, `declaration_${employeeId}_${year}_${month}.pdf`);
  },
  exportPdfConsolidated: async (year, month) => {
    const res = await declarationApi.get('/export/pdf/consolidated', {
      params: { year, month },
      responseType: 'blob',
    });
    downloadBlob(res.data, `declarations_${year}_${month}.pdf`);
  },
  exportPdfYear: async (employeeId, year) => {
    const res = await declarationApi.get('/export/pdf/year', {
      params: { employeeId, year },
      responseType: 'blob',
    });
    downloadBlob(res.data, `declarations_${employeeId}_${year}.pdf`);
  },
  exportPdfRange: async (employeeId, startYear, startMonth, endYear, endMonth) => {
    const res = await declarationApi.get('/export/pdf/range', {
      params: { employeeId, startYear, startMonth, endYear, endMonth },
      responseType: 'blob',
    });
    downloadBlob(res.data, `declarations_${employeeId}_${startYear}-${startMonth}_to_${endYear}-${endMonth}.pdf`);
  },
  exportExcel: async (employeeId, year, month) => {
    const res = await declarationApi.get('/export/excel', {
      params: { employeeId, year, month },
      responseType: 'blob',
    });
    downloadBlob(res.data, `declaration_${employeeId}_${year}_${month}.xlsx`);
  },
  exportExcelConsolidated: async (year, month) => {
    const res = await declarationApi.get('/export/excel/consolidated', {
      params: { year, month },
      responseType: 'blob',
    });
    downloadBlob(res.data, `declarations_${year}_${month}.xlsx`);
  },
  exportExcelYear: async (employeeId, year) => {
    const res = await declarationApi.get('/export/excel/year', {
      params: { employeeId, year },
      responseType: 'blob',
    });
    downloadBlob(res.data, `declarations_${employeeId}_${year}.xlsx`);
  },
  exportExcelRange: async (employeeId, startYear, startMonth, endYear, endMonth) => {
    const res = await declarationApi.get('/export/excel/range', {
      params: { employeeId, startYear, startMonth, endYear, endMonth },
      responseType: 'blob',
    });
    downloadBlob(res.data, `declarations_${employeeId}_${startYear}-${startMonth}_to_${endYear}-${endMonth}.xlsx`);
  },
};

const downloadBlob = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export default declarationService;

